import { type ReactElement } from 'react'
import { createFileRoute, useLocation } from '@tanstack/react-router'
import { useConnectFeature, useRedirect, useTerrosMcpFeature } from '@hooks'
import { useProfile } from '@front/model'
import { NestedNavigation } from '@components'
import { useIntegrationRoutes } from '../../components/appShell/useIntegrationRoutes'
import { TERROS_MCP_PATH } from '../../components/appShell/terrosMcpRoute'

function Integration(): ReactElement {
  const routes = useIntegrationRoutes()
  const { isEnabled: isConnectEnabled, isLoading: isConnectLoading } = useConnectFeature()
  const { isEnabled: isTerrosMcpEnabled, isLoading: isTerrosMcpLoading } = useTerrosMcpFeature()
  const { isAdmin, hasPermission } = useProfile()
  const location = useLocation()
  const isRootIntegrationRoute = location.pathname === '/integration'

  const getDefaultPath = (): string => {
    if (isConnectEnabled && hasPermission('install:manage')) return '/integration/marketplace'
    if (isConnectEnabled && hasPermission('app:manage')) return '/integration/developer'
    if (isAdmin) return '/integration/import'
    if (hasPermission('export:manage')) return '/integration/export'
    if (hasPermission('apikey:manage')) return '/integration/apikey'
    if (hasPermission('webhook:manage')) return '/integration/webhook'
    if (isTerrosMcpEnabled) return TERROS_MCP_PATH
    return '/integration'
  }
  useRedirect(getDefaultPath(), isRootIntegrationRoute && !isConnectLoading && !isTerrosMcpLoading)

  return <NestedNavigation sectionLabel='Integrations' routes={routes} />
}

export const Route = createFileRoute('/integration')({
  component: Integration,
})
